import { render } from "./RegisterAgent.vue?vue&type=template&id=684151da"
import script from "./RegisterAgent.vue?vue&type=script&lang=js"
export * from "./RegisterAgent.vue?vue&type=script&lang=js"

import exportComponent from "/home/reportadmin/public_html/app_prod/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__